import { useParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

import { isValidUUID } from 'app/utils';

export default function ServiceTemplateGuard({ children }) {
  const { serviceTemplateId, organisationId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isValidUUID(serviceTemplateId)) {
      const redirectUrl =
        serviceTemplateId === 'new-service-template'
          ? `/service-templates/${serviceTemplateId}/organisations/${organisationId}/settings`
          : `/service-templates?organisationId=${organisationId}`;
      navigate(redirectUrl);
    }
  }, [serviceTemplateId, organisationId, navigate]);

  if (!isValidUUID(serviceTemplateId)) {
    return null;
  }

  return children;
}
